<template>
    <select v-bind:name="name" class="form-control m-input" :class="inputClass" v-bind:id="id">
        <option :value="null">{{$t('Please choose')}}</option>
        <option v-for="(value, key) in options" :key="key" :value="value">{{value}}</option>
    </select>
</template>

<script>
export default {
  name: 'SelectableComponent',
  props: ['id', 'name', 'inputClass', 'value', 'options']
}
</script>



// WEBPACK FOOTER //
// src/components/core/form/inputs/SelectableComponent.vue